import { POSITION_CONFIGS, normalizePositionTitle } from '../config/positionConfigs';

const GOOGLE_SHEETS_API_ENDPOINT = 'https://script.google.com/macros/s/AKfycbwrsrQselVcyXiJOmdcDTjN0GG1GSmuGxIK2PK4o_Pt59zPij0Shzp0o0rIMwxTtX_Reg/exec';

export const submitToGoogleSheets = async (formData) => {
  try {
    const normalizedPosition = normalizePositionTitle(formData.position);
    
    console.log('Submitting application:', {
      position: normalizedPosition,
      level: formData.level,
      // Log other relevant fields but omit sensitive data
    });

    // Get position-specific fields
    const config = POSITION_CONFIGS[normalizedPosition];
    const additionalFields = config ? config.additionalFields.reduce((acc, field) => {
      acc[field] = formData[field] || '';
      return acc;
    }, {}) : {};

    // Check if internationalization is in additionalFields
    console.log('Additional fields:', additionalFields);

    // Create URL encoded data with base fields and additional fields
    const formDataUrlEncoded = new URLSearchParams({
      position: normalizedPosition,
      level: formData.level,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      techExpertise: formData.techExpertise,
      aiExperience: formData.aiExperience,
      portfolio: formData.portfolio,
      englishFluency: formData.englishFluency,
      noticePeriod: formData.noticePeriod,
      resumeLink: formData.resumeLink,
      // Add the new fields for Full Stack Engineer
      microservices: formData.microservices || '',
      teamLeadership: formData.teamLeadership || '',
      agile: formData.agile || '',
      internationalization: formData.internationalization || '',
      // Add the new fields for Technical Project Manager
      methodologies: formData.methodologies || '',
      communication: formData.communication || '',
      ecommerce: formData.ecommerce || '',
      timestamp: new Date().toISOString(),
      ...additionalFields  // Include any additional fields from the config
    }).toString();

    console.log('Data being sent to sheet:', Object.fromEntries(new URLSearchParams(formDataUrlEncoded)));

    const response = await fetch(GOOGLE_SHEETS_API_ENDPOINT, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formDataUrlEncoded
    });

    // Since we're using no-cors, we can't access the response
    // We'll assume success if no error is thrown
    return {
      status: 'success',
      message: 'Application submitted successfully'
    };
  } catch (error) {
    console.error('Submission error:', error);
    throw error;
  }
}; 